import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faDiagramCells } from '@fortawesome/pro-light-svg-icons';

export type ProLightDiagramCellsProps = IconComponentProps;

export const ProLightDiagramCells = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightDiagramCellsProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faDiagramCells}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faDiagramCells}
    />
  );
};

ProLightDiagramCells.displayName = 'ProLightDiagramCells';
